(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealSelectors = [
    '.raydo-badge',
    '.raydo-mobile-device-preview',
    '#hero-title',
    '.raydo-hero-inner .raydo-body-lg',
    '.raydo-feature-list',
    '.raydo-button-row',
    '.raydo-note-row',
    '.raydo-hero-visual',
    '.raydo-trust-shell',
    '.raydo-section-heading',
    '.raydo-step-card',
    '.raydo-info-card',
    '.raydo-demo-card',
    '.raydo-mid-cta',
    '.raydo-logo-group',
    '.raydo-compare',
    '.raydo-scale-card',
    '.raydo-plan',
    '.raydo-faq',
    '.raydo-final-cta',
    '.raydo-site-footer__grid > *'
  ];
  var animated = [];

  revealSelectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (element, index) {
      if (element.hasAttribute('data-reveal')) {
        return;
      }

      element.setAttribute('data-reveal', '');
      element.style.setProperty('--reveal-delay', Math.min(index * 70, 280) + 'ms');
      animated.push(element);
    });
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    animated.forEach(function (element) {
      element.classList.add('is-visible');
    });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    });

    animated.forEach(function (element) {
      observer.observe(element);
    });
  }

  document.querySelectorAll('[data-count-value]').forEach(function (element) {
    var target = Number(element.getAttribute('data-count-value'));
    var decimals = Number(element.getAttribute('data-count-decimals') || '0');
    var suffix = element.getAttribute('data-count-suffix') || '';
    var formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
    var finalText = formatter.format(target) + suffix;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      element.textContent = finalText;
      return;
    }

    var played = false;
    var counter = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || played) {
          return;
        }

        played = true;
        var start = performance.now();
        var duration = 1200;

        function tick(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          element.textContent = formatter.format(value) + suffix;

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            element.textContent = finalText;
          }
        }

        requestAnimationFrame(tick);
        counter.unobserve(element);
      });
    }, {
      threshold: 0.6
    });

    counter.observe(element);
  });
}());
